/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sv-question-standard-actions[_ngcontent-%COMP%]{margin-top:30px;display:flex;justify-content:space-between}.button[_ngcontent-%COMP%]{min-width:60px}@media (min-width:768px){.button[_ngcontent-%COMP%]{min-width:120px}}"];
export { styles as styles };
